import { render, staticRenderFns } from "./BolTemplate.vue?vue&type=template&id=000ac600&scoped=true"
import script from "./BolTemplate.vue?vue&type=script&lang=js"
export * from "./BolTemplate.vue?vue&type=script&lang=js"
import style0 from "./BolTemplate.vue?vue&type=style&index=0&id=000ac600&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ac600",
  null
  
)

export default component.exports